import { createTranslations } from '@npco/utils-translations'

export const sessionTimeoutModalTranslations = createTranslations({
  title: 'Are you still there?',
  description: 'You will be logged out soon, due to inactivity.',
  logOutButton: 'Log Out',
  stayLoggedInButton: 'Stay Logged In',
  imageAlt: 'A hand holding a key near a keyhole',
})
